<script lang="ts" setup>
import { AkNavigation, AkNavigationItem } from '@ankorstore/design-system';
import { useI18n } from 'vue-i18n';

defineProps<{
  navigationItems: Array<AkNavigationItem>;
  opened: boolean;
}>();

const { t } = useI18n();
</script>

<template>
  <div class="mobile-navigation-brand">
    <AkHeading3>{{ t('shared.menu.marketplace') }}</AkHeading3>
    <AkNavigation
      v-if="opened"
      :use-router-link="true"
      is-mobile
      :items="navigationItems"
    />
  </div>
</template>

<style lang="css" scoped>
.mobile-navigation-brand {
  @apply ds-mt-4;
}
</style>
